import { useTheme } from '@mui/material';
const useAlertsListStyles = () => {
    const theme = useTheme();
    const HeaderHeight = '48px';
    const BottomNavigationHeight = '56px';
    const SectionHeaderHeight = '50px';
    return {
        ContainerStyles: {
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            p: 0,
            background: theme.palette.background.paper
        },
        ContentContainerStyles: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingBottom: 2,
            height: `calc(100dvh - ${HeaderHeight} - ${BottomNavigationHeight} - ${SectionHeaderHeight})`,
            overflowY: 'auto'
        }
    };
};
export default useAlertsListStyles;
